import React from 'react'
import { useTranslation } from 'react-i18next';
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';

export default function QandABuilder() {
  const { t } = useTranslation();
  const image001 = useDocImage('qanda-builder-img', 'image001.png');
  const image002 = useDocImage('qanda-builder-img', 'image002.png');
  const image003 = useDocImage('qanda-builder-img', 'image003.png');
  const image004 = useDocImage('qanda-builder-img', 'image004.png');
  const image005 = useDocImage('qanda-builder-img', 'image005.png');
  const image006 = useDocImage('qanda-builder-img', 'image006.png');
  const image007 = useDocImage('qanda-builder-img', 'image007.png');
  const image008 = useDocImage('qanda-builder-img', 'image008.png');
  const image009 = useDocImage('qanda-builder-img', 'image009.png');
  const image010 = useDocImage('qanda-builder-img', 'image010.png');
  const image011 = useDocImage('qanda-builder-img', 'image011.png');
  const image012 = useDocImage('qanda-builder-img', 'image012.png');
  const image013 = useDocImage('qanda-builder-img', 'image013.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.qandaBuilder.title')}</h1>
              <p className='header-para mb-10'>
                {t('documentation.qandaBuilder.intro')}
                </p>
                <ul>
                <li>{t('documentation.qandaBuilder.introItems.organize')}</li>
                  <li>{t('documentation.qandaBuilder.introItems.questionTypes')}</li>
                  <li>{t('documentation.qandaBuilder.introItems.editManage')}</li>
                  <li>{t('documentation.qandaBuilder.introItems.navigate')}</li>
                  </ul>
                <img src={image003} alt={t('documentation.qandaBuilder.access.imageAlt')} className='img-fluid pt-10 pb-30' />
            
                  
                 
              
             

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.qandaBuilder.access.title')}
                </div>
                <div className="card-body">

                  <ul>
                    <li>  {t('documentation.qandaBuilder.access.step1')}
                      <img src={image001} alt={t('documentation.qandaBuilder.access.imageAlt')} className='img-fluid pb-10 pt-10' />
                    </li>
                    <li>{t('documentation.qandaBuilder.access.step2')} <br />
                      <img src={image002} alt={t('documentation.qandaBuilder.access.imageAlt')} className='img-fluid pt-10 pb-10' />
                    </li>

                  </ul>

                </div>
              </div>
              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.qandaBuilder.surveyInfo.title')}
                </div>
                <div className="card-body">
                  <p>  </p>
                  <ul>
                  <img src={image004} alt={t('documentation.qandaBuilder.surveyInfo.imageAlt')} className='img-fluid pt-10 pb-10' />
                    <li>

                     <b>{t('documentation.qandaBuilder.surveyInfo.surveyTitleLabel')}</b> {t('documentation.qandaBuilder.surveyInfo.surveyTitleValue')}
                    </li>
                    <li><b>{t('documentation.qandaBuilder.surveyInfo.surveyDescriptionLabel')}</b> {t('documentation.qandaBuilder.surveyInfo.surveyDescriptionValue')}</li>
                    <li>{t('documentation.qandaBuilder.surveyInfo.duplicateNote')} <br />
                     
                    </li>
                    <li><b>{t('documentation.qandaBuilder.surveyInfo.statsLabel')}</b> {t('documentation.qandaBuilder.surveyInfo.statsValue')}</li>
                    <li>
                      
                    <b>{t('documentation.qandaBuilder.surveyInfo.exampleLabel')}</b>, {t('documentation.qandaBuilder.surveyInfo.exampleDesc')}
                      <img src={image005} alt={t('documentation.qandaBuilder.surveyInfo.imageAlt')} className='img-fluid pb-10 pt-10' />
                    </li>
                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.qandaBuilder.sectionsQuestions.title')}
                </div>
                <div className="card-body">
                  <img src={image010} alt={t('documentation.qandaBuilder.sectionsQuestions.imageAlt')} className='img-fluid pt-10 pb-30' />
                  <p><b>{t('documentation.qandaBuilder.sectionsQuestions.sectionTitle')}</b> {t('documentation.qandaBuilder.sectionsQuestions.sectionDesc')}</p>
                  <ul>
                    <li> {t('documentation.qandaBuilder.sectionsQuestions.sectionItems.focus')}</li>
                    <li>{t('documentation.qandaBuilder.sectionsQuestions.sectionItems.describes')}</li>
                    <li>{t('documentation.qandaBuilder.sectionsQuestions.sectionItems.questionsCount')}</li>
                    <li> {t('documentation.qandaBuilder.sectionsQuestions.sectionItems.iconsNote')}
                      <img src={image006} alt={t('documentation.qandaBuilder.sectionsQuestions.imageAlt')} className='img-fluid  pb-10' />
                    </li>
                    <li>{t('documentation.qandaBuilder.sectionsQuestions.sectionItems.exampleQuestionsTitle')}
                      {t('documentation.qandaBuilder.sectionsQuestions.sectionItems.exampleQuestion1')}</li>
                    <li>
                      {t('documentation.qandaBuilder.sectionsQuestions.sectionItems.exampleQuestion2')}
                    </li>
                    <li> {t('documentation.qandaBuilder.sectionsQuestions.sectionItems.questionIcons')}
                      <img src={image007} alt={t('documentation.qandaBuilder.sectionsQuestions.imageAlt')} className='img-fluid pt-10 pb-10' />
                    </li>

                  </ul>

                  <p><b>{t('documentation.qandaBuilder.addButtons.title')}</b></p>
                  <img src={image008} alt={t('documentation.qandaBuilder.addButtons.imageAlt')} className='pt-10 pb-20' />
                  <ul>
                    <li><b>{t('documentation.qandaBuilder.addButtons.addQuestionTitle')}</b>  - {t('documentation.qandaBuilder.addButtons.addQuestionDesc')}
                    </li>
                    <li><b>{t('documentation.qandaBuilder.addButtons.addSectionTitle')}</b>  - {t('documentation.qandaBuilder.addButtons.addSectionDesc')}
                    </li>
                  </ul>


                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.qandaBuilder.questionTypes.title')}
                </div>
                <div className="card-body">
                  <img src={image009} alt={t('documentation.qandaBuilder.questionTypes.imageAlt')} className='img-fluid pt-10 pb-30' />
                  <p> {t('documentation.qandaBuilder.questionTypes.intro')}</p>
                  <ul className='pt-10'>
                    <li> <b>{t('documentation.qandaBuilder.questionTypes.multipleChoiceTitle')}</b> {t('documentation.qandaBuilder.questionTypes.multipleChoiceDesc')}
                      <img src={image011} alt={t('documentation.qandaBuilder.questionTypes.imageAlt')} className='img-fluid pt-20 pb-30' />
                    </li>
                    <li> <b>{t('documentation.qandaBuilder.questionTypes.textTitle')}</b> {t('documentation.qandaBuilder.questionTypes.textDesc')}
                      <img src={image012} alt={t('documentation.qandaBuilder.questionTypes.imageAlt')} className='img-fluid pt-20 pb-30' />
                    </li>
                    <li><b>{t('documentation.qandaBuilder.questionTypes.opinionTitle')}</b> {t('documentation.qandaBuilder.questionTypes.opinionDesc')}
                      <img src={image013} alt={t('documentation.qandaBuilder.questionTypes.imageAlt')} className='img-fluid pt-20 pb-10' />
                    </li>
                  </ul>


                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
